import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE = 'https://revexia.ai/api';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [status, setStatus] = useState('Verifying...');

  useEffect(() => {
    if (token) {
      axios.get(`${API_BASE}/auth/verify-email?token=${token}`)
        .then(response => {
          if (response.status === 200) {
            navigate('/auth');
          }
        })
        .catch(error => {
          setStatus('Verification failed. Invalid or expired token.');
        });
    } else {
      setStatus('No token provided.');
    }
  }, [token, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#0a0a0a', color: '#fff' }}>
      <h2>{status}</h2>
    </div>
  );
};

export default VerifyEmail;
